module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Tunis2.d0b41ebd.jpg";